//Google Analytics Event Tracking
$("a").on('click', function() {
  var addressValue = $(this).attr("href");

  if (addressValue.indexOf("mailto:") >= 0) {
    var emailAddress = addressValue.replace('mailto:', '');
    console.log('mail Link');

    ga('send', {
      hitType: 'event',
      eventCategory: 'Email Link',
      eventAction: 'Link Click',
      eventLabel: emailAddress
    });
  }

  else if (addressValue.indexOf("tel:") >= 0) {
    var emailAddress = addressValue.replace('mailto:', '');
    console.log('mail Link');

    ga('send', {
      hitType: 'event',
      eventCategory: 'Phone Number Link',
      eventAction: 'Link Click/Tap',
      eventLabel: emailAddress
    });
  }
})

$(".page__copy a").on('click', function() {
  var addressValue = $(this).attr("href");

  if (!(addressValue.indexOf("mailto:") >= 0) && !(addressValue.indexOf("tel:") >= 0)) {

    ga('send', {
      hitType: 'event',
      eventCategory: 'Page Copy Section Link',
      eventAction: 'Link Click',
      eventLabel: addressValue
    });
  }
});

$(".file-link").on('click', function() {
  var addressValue = $(this).attr("href");

  ga('send', {
    hitType: 'event',
    eventCategory: 'File Link',
    eventAction: 'Download',
    eventLabel: addressValue
  });
});


// WEBPACK FOOTER //
// ./js/event-tracking.js